import React, { Fragment, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import ContactSection2 from '../../components/ContactSection';
import Layout from '../../components/Layout/Layout';
import icon from '../../images/icon/music-icon.svg';
import bImg1 from '../../images/logo-fff.png';
import Seo from '../../components/Seo';

const ContactPage = (props) => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();

    // Set language based on URL parameter
    useEffect(() => {
        if (lang && (lang === 'en' || lang === 'ka')) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    // Lazy-load reCAPTCHA only on the Contact page
    useEffect(() => {
        const scriptId = 'recaptcha-script';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://www.google.com/recaptcha/api.js';
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
        }
        return () => {
            // Clean up when leaving Contact page
            const existing = document.getElementById(scriptId);
            if (existing) existing.remove();
        };
    }, []);

    return (
        <Fragment>
            <Seo 
                title={t('seo.contact.title')}
                description={t('seo.contact.description')}
                keywords={t('seo.contact.keywords')}
                url={`/${lang}/contact`}
            />
            <Layout>
                
                {/* Hero Section with Animation */}
                <motion.section
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="page-title pt-150 pos-rel bg_img"
                >
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <motion.div 
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: 0.3 }}
                                        className="page-title-box"
                                    >
                                        <motion.span 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0.5 }}
                                            className="sub-title"
                                        >
                                            <img src={icon} alt="" /> {t('contact.title')}
                                        </motion.span>
                                        <motion.h2 
                                            initial={{ opacity: 0, y: 30 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.7 }}
                                            className="title"
                                        >
                                            {t('contact.subtitle')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                                <div className="col-lg-3 mt-30 justify-content-center d-flex">
                                    <motion.div 
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.9, duration: 0.5 }}
                                        className="sd-right-img pos-rel"
                                    >
                                        <img src={bImg1} alt="" />
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                {/* Contact Sections with Animation */}
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                >
                    <ContactSection2 />
                </motion.div>
            </Layout>
        </Fragment>
    );
};

export default ContactPage;